import axios from './_nestAxios'

export const obtenerPresentacionesAsInfoPrecios = dto =>
  axios.get('/productos', {
    params: {
      ...dto,
      tipoConsulta: 'presentaciones-info-precios'
    }
  })

export const obtenerPreciosxIdPresentacion = id => axios.get(`/productos/presentaciones/resumen-precios/${id}`)

export const obtenerStockxIdProducto = id => axios.get(`/productos/stock/${id}`)
/*
export const importarExcelProductos = data => axios.post('/productos/importar/productos', data)
*/
export const importarExcelProductos = data =>
  axios.post('/productos/importar/productos', data, {
    responseType: 'blob'
  })

export const importarExcelPrecios = data => axios.post('/productos/importar/precios', data)

export const getProducto_Compras = _id =>
  axios.get(`/productos/presentaciones/${_id}`, {
    params: {
      tipoConsulta: 'compras'
    }
  })

export const obtenerAsCombustibles = () => axios.get('/productos/combustibles')

export const getNuevoCodigo = () => axios.get('/productos/nuevo-codigo')

export const actualizarProducto = (_id, data) => axios.put(`/productos/${_id}`, data)

export const eliminarProducto = _id => axios.delete(`/productos/${_id}`)

export const generarCopia = (_id, data) => axios.post(`/productos/${_id}/generar-copia`, data)

export const getProducto = _id => axios.get(`/productos/${_id}`)

export const nuevoProducto = data => axios.post('/productos/nuevo', data)

export const nuevoFormulaDeProducto = (idProducto, data) => axios.post(`/productos/${idProducto}/formula`, data)

export const eliminarFormulaDeProducto = (idProducto, idFormula) =>
  axios.delete(`/productos/${idProducto}/formula/${idFormula}`)

export const obtenerAsVentasSelect2 = ({ busqueda, idListaPrecio, tipo }) =>
  axios.get('/productos', { params: { busqueda, tipo, idListaPrecio, tipoConsulta: 'select2-ventas' } })

export const obtenerAsInventariosSelect2 = ({ busqueda, tipo }) =>
  axios.get('/productos', { params: { busqueda, tipo, tipoConsulta: 'select2-inventarios' } })

export const obtenerSoloTerminadosAsSelect = () =>
  axios.get('/productos', { params: { tipoConsulta: 'select-terminados' } })

export const obtenerAsComprasSelect2 = ({ busqueda, tipo }) =>
  axios.get('/productos', { params: { busqueda, tipoConsulta: 'select2-compras', tipo: tipo } })

export const obtenerAsPromocionesSelect2 = ({ busqueda }) =>
  axios.get('/productos', { params: { busqueda, tipoConsulta: 'select2-promociones' } })

export const obtenerAsSelect2Presentaciones = ({ busqueda }) =>
  axios.get('/productos', { params: { busqueda, tipoConsulta: 'select2-presentaciones' } })

export const obtenerAsSelect2 = ({ busqueda }) =>
  axios.get('/productos', { params: { busqueda, tipoConsulta: 'select2' } })

export const descargarPlantillaImportarProductos = () =>
  axios.get('/productos/descargar/plantilla/importar-productos', {
    responseType: 'blob'
  })

export const descargarPlantillaImportarPrecios = () =>
  axios.get('/productos/descargar/plantilla/importar-precios', {
    responseType: 'blob'
  })

export const descargarInformePrecios = () =>
  axios.get('/productos/descargar/informe-precios', {
    responseType: 'blob'
  })

export const descargarInformeProductos = () =>
  axios.get('/productos/descargar/informe-productos', {
    responseType: 'blob'
  })

export const descargarInformeProductosAsSaldosIniciales = () =>
  axios.get('/productos/descargar/informe-productos-saldo-inicial', {
    responseType: 'blob'
  })

export const obtenerPresentacionPrecioxId = id => axios.get(`/productos/presentaciones/precios/${id}`)

export const actualizarPresentacionPrecioxData = data => axios.put(`/productos/presentaciones/precios`, data)

export const getProducto_Ventas = (_id, idListaPrecio) =>
  axios.get(`/productos/presentaciones/${_id}`, {
    params: {
      tipoConsulta: 'ventas',
      idListaPrecio: idListaPrecio
    }
  })

export const getProducto_Ventas_CodigoBarras = (codigoBarras, idListaPrecio) =>
  axios.get(`/productos/presentaciones/${codigoBarras}`, {
    params: {
      tipoConsulta: 'ventas-codigo-barras',
      idListaPrecio: idListaPrecio
    }
  })
